import Formatter from 'src/class/Formatter';
import i18n from 'src/i18n';
import Tables from 'src/class/Tables';

const configTable = () => {
  const Table = { ...Tables.Table };

  Table.tableColumns = [
    {
      prop: 'worker.document_id',
      label: 'Cedula',
      minWidth: 120,
      sortable: true,
      fixed: true,
      align: 'center',
    },
    {
      prop: 'worker.name',
      minWidth: 120,
      label: 'Nombres',
      fixed: true,
    },
    {
      prop: 'worker.code',
      minWidth: 120,
      label: 'Cod. Empleado',
      fixed: true,
      align: 'center',
    },
    {
      prop: 'labor_activity_homologated_code',
      minWidth: 120,
      label: 'Cod. Hom.',
      fixed: true,
      align: 'center',
    },
    {
      prop: 'labor_activity_name',
      minWidth: 120,
      label: 'Actividad',
    },
    {
      prop: 'labor_activity_time_price',
      minWidth: 120,
      label: 'Recargo',
      align: 'center',
    },
    {
      prop: 'worker.salary',
      minWidth: 120,
      label: 'Salario',
      align: 'center',
    },
    {
      prop: 'worker.hourly_rate',
      minWidth: 120,
      label: 'Hora Salario',
      align: 'center',
    },
    {
      prop: 'labor_activity_price',
      minWidth: 120,
      label: 'Valor Num. Importe',
      align: 'center',
    },
    {
      prop: 'worker.hours_worked',
      minWidth: 120,
      label: 'Cantidad Horas',
      align: 'center',
    },
    {
      prop: 'worker.check_in',
      minWidth: 120,
      label: 'Hora Entrada',
      align: 'center',
    },
    {
      prop: 'worker.check_out',
      minWidth: 120,
      label: 'Hora Salida',
      align: 'center',
    },
    {
      prop: 'labor_activity_unit_payment',
      minWidth: 120,
      label: 'Und. Medida',
      align: 'center',
    },
    {
      prop: 'date_save',
      minWidth: 120,
      label: 'Fecha',
      align: 'center',
    },
    {
      prop: 'worker.department',
      minWidth: 120,
      label: 'Departamento',
    },
    {
      prop: 'farm_name',
      minWidth: 120,
      label: 'Finca',
    },
    {
      prop: 'observations',
      minWidth: 120,
      label: 'Observación',
    },
  ];

  const Search = { ...Tables.Search };

  return { Table, Search };
};

export default configTable;
